import {
  ValidationMessage,
  ValidationMessageFunction,
} from "@/models/validation-message";
import { z } from "zod";

export const getNameAndPhoneSchema = () =>
  z
    .object({
      name: z
        .string()
        .nonempty({ message: ValidationMessage.NON_EMPTY })
        .optional(),
      phone: z
        .string()
        .nonempty({ message: ValidationMessage.NON_EMPTY })
        .max(30, ValidationMessageFunction.MAX(30))
        .optional(),
    })
    .optional();
